import * as echarts from 'echarts'
export const getOption = () => {
  return {
    grid: {
      top: 30,
      bottom: 30,
      left: 60,
      right: 60
    },
    xAxis: {
      max: 'dataMax',
      splitLine: {
        show: true,
        lineStyle: {
          color: '#C9D3F5',
          width: 0.5,
          type: 'dashed'
        }
      },
      axisLabel: {
        color: '#ffffff'
      }
    },
    yAxis: {
      axisLabel: {
        color: '#ffffff'
      },
      axisLine: {
        lineStyle: { color: '#ffffff' }
      },
      splitLine: { show: false },
      type: 'category',
      inverse: true,
      animationDuration: 300,
      animationDurationUpdate: 300,
      max: 9 // only the largest 9 bars will be displayed
    },
    animationDuration: 0,
    animationDurationUpdate: 3000,
    animationEasing: 'linear',
    animationEasingUpdate: 'linear',
    series: [
      {
        realtimeSort: true,
        name: 'X',
        type: 'bar',
        // showBackground: true,
        data: [],
        barWidth: 10,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: '#327AFD' },
            { offset: 1, color: '#68FFD3' }
          ])
        },
        label: {
          show: true,
          position: 'right',
          valueAnimation: true
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/sortBar/getOption.js